export default __webpack_public_path__ + "static/media/m-logo.15080b92.svg";